import {QueryState} from '../../../../../_dashboard/helpers'

/**
 * react-table column id → MongoDB field used in ReservationService.findAll().sort()
 * (nested "name" sorts use the ObjectId ref on the document).
 */
const RESERVATION_SORT_FIELD: Record<string, string> = {
  'hotel.name': 'hotel',
  paymentMethod: 'paymentMethod',
  status: 'status',
  totalPrice: 'totalPrice',
  checkInDate: 'checkInDate',
  createdAt: 'createdAt',
}

/**
 * API attend un seul query param `sort` (-field pour desc). Le state UI garde sort + order.
 */
export function buildReservationApiQuery(state: QueryState): Record<string, unknown> {
  const {sort: sortCol, order, ...rest} = state as QueryState & {
    sort?: string
    order?: 'asc' | 'desc'
  }

  const params: Record<string, unknown> = {
    ...rest,
  }

  if (sortCol && order) {
    const field = RESERVATION_SORT_FIELD[sortCol] ?? sortCol.replace(/^-/, '')
    params.sort = order === 'desc' ? (field.startsWith('-') ? field : `-${field}`) : field.replace(/^-/, '')
  }

  return params
}
